import CodeUserStoryStatusList from "./pages/ListPage.vue";
import CodeUserStoryStatusDetail from "./pages/FormPage.vue";
import CodeUserStoryStatusIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_user_story_status",
    component: CodeUserStoryStatusIndex,
    redirect: "/code_user_story_status/list",
    name: "code_user_story_status",
    children: [
      {
        path: "list",
        component: CodeUserStoryStatusList,
        name: "code_user_story_status.list",
      },
      {
        path: "create",
        component: CodeUserStoryStatusDetail,
        name: "code_user_story_status.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeUserStoryStatusDetail,
        name: "code_user_story_status.edit",
        props: { create: false },
      },
    ],
  },
];
